import { connect } from 'react-redux';

import { MoreParametersPikBanner } from './MoreParametersPikBanner';
import { IAppState } from '../../../../../common/state';

export function mapStateToProps(state: IAppState) {
  return {
    isRedesign: state.isFiltersRedesignEnabled,
  };
}

export const MoreParametersPikBannerContainer = connect(mapStateToProps)(MoreParametersPikBanner);
